import { render, staticRenderFns } from "./verifyCode.vue?vue&type=template&id=ad5b21fa&scoped=true&"
import script from "./verifyCode.vue?vue&type=script&lang=js&"
export * from "./verifyCode.vue?vue&type=script&lang=js&"
import style0 from "./verifyCode.vue?vue&type=style&index=0&id=ad5b21fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5b21fa",
  null
  
)

export default component.exports